<template>
  <div>
    <h2 qid="notifications-page-title">
      {{ $t('notifications.page_title') }}
    </h2>
    <br>
    <div class="card">
      <div class="card-body">
        <div class="notifications-page__actions">
          <button type="button"
                  class="btn btn-link p-0"
                  @click="markAllRead"
                  qid="notifications-page-mark-all-read"
          >
            {{ $t('app_nav.notifications_mark_all_read') }}
          </button>
        </div>
        <NotificationItem
            v-for="notification in items"
            :key="notification.id"
            :notification="notification"
            @open="markRead"
        />
        <InfiniteLoading @infinite="loadingHandler">
          <template slot="no-results">
            <span>
              {{ $t('system.no_notifications') }}
            </span>
          </template>
          <template slot="no-more"><span></span></template>
        </InfiniteLoading>
      </div>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import InfiniteLoading from 'vue-infinite-loading';
import NotificationItem from '@/components/notification/NotificationItem.vue';

export default {
  name: 'NotificationPage',
  data: function() {
    return {
      items: [],
      cursor: null,
    }
  },
  components: {
    InfiniteLoading,
    NotificationItem
  },
  methods: {
    // Loads 20 at a time with the cursor from the previous page (US 9372).
    loadingHandler($state) {
      let self = this

      piincHttp.get('users/me/notifications', { params: {
        status: 'all',
        per_page: 20,
        cursor: this.cursor || undefined
      }}).then(({ data }) => {
        self.items.push(...data.data);
        self.cursor = data.next_cursor;
        if (data.data.length) {
          $state.loaded();
        }
        if (!self.cursor) {
          $state.complete();
        }
      }, function() {
        $state.complete();
      });
    },
    markRead(notification) {
      if (notification.read_at) {
        return;
      }
      notification.read_at = new Date().toISOString();
      piincHttp.put('users/me/notifications/' + notification.id + '/read').then(() => {
        this.$store.commit('storeReloadCount');
      }, function() {});
    },
    markAllRead() {
      let self = this;
      piincHttp.put('users/me/notifications/read').then(function() {
        let now = new Date().toISOString();
        self.items.forEach(function(item) {
          if (!item.read_at) {
            item.read_at = now;
          }
        });
        self.$store.commit('storeReloadCount');
      }, function() {});
    }
  }
}
</script>
